import React, { useState } from "react";
import PopupExpIcon from "../../../Icons/PopupExpIcon";
import MapPinIcon from "../../../Icons/MapPinIcon";
import { Hotspot, TourData } from "../../../../Types";
import { useViewerPopupStore } from "../../../../state management/zustand/viewer-stores";

function TextPopup(props: {
  tourData: TourData;
  popup: Hotspot;
  zoom: number;
}) {
  const { tourData, popup, zoom } = props;
  const [clicked, setClicked] = useState<boolean>(false);
  const { setOpen } = useViewerPopupStore();

  return (
    <>
      {tourData.popups.find((one: any) => one.id === popup.target)!.text ? (
        <div
          tooltip-text={
            tourData.popups.find((one: any) => one.id === popup.target)!.title
          }
          className="viewer-exp-icon"
        >
          <PopupExpIcon
            className="viewer-exp-elem"
            onClick={() => {
              setOpen(popup.target!);
            }}
            width="4rem"
            height="4rem"
            fill="white"
            stroke="#222"
            strokeWidth="25px"
            style={{ opacity: ((zoom - 15) * 100) / 76 <= 30 ? 0.3 : 1 }}
          />
        </div>
      ) : (
        <div
          tooltip-text={
            tourData.popups.find((one: any) => one.id === popup.target)!.title
          }
          className="viewer-exp-icon"
          id={clicked ? "clicked" : undefined}
          onClick={() => setClicked(!clicked)}
        >
          <MapPinIcon
            fill={"#fff"}
            width="3.2rem"
            height="3.4rem"
            className="map-pin-icon"
            style={{ opacity: ((zoom - 15) * 100) / 76 <= 30 ? 0.3 : 1 }}
          />
        </div>
      )}
    </>
  );
}

export default TextPopup;
